import { animated } from 'react-spring';
import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  height: 100%;
  width: 100%;
  z-index: 1000;

  background: transparent;
`;

export const Container = styled(animated.div)`
  position: fixed;
  top: 0;
  right: 0;

  width: 25rem;
  height: 100%;

  z-index: 999;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  padding: 3rem 2rem 2rem 2rem;
  border-top-left-radius: 5rem;
  gap: 2rem;

  @keyframes transformEntryAnimation {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes transformExitAnimation {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  animation: transformEntryAnimation 0.3s;

  &.closing {
    animation: transformExitAnimation 0.3s;
  }

  .button-clean-cart {
    cursor: pointer;
    color: var(--gray);
    font-size: 0.9rem;
    font-weight: 700;
    position: absolute;
    top: 1rem;
    right: 2rem;
    transition: color 0.3s;

    &:hover {
      color: var(--primary_color);
    }
  }

  .mini-cart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      color: var(--primary_color);
      font-size: 1.4rem;
      font-weight: 900;
    }
  }

  .mini-cart-header > div {
    display: flex;
    align-items: center;
    gap: 1rem;

    img {
      width: 2rem;
      max-width: 1.75rem;
    }
  }

  .products-list-mini-cart {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 1rem;
    margin-right: -0.6rem;

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    scroll-margin-left: 1rem;
    scrollbar-track-color: transparent;
    ::-webkit-scrollbar {
      width: 0.4rem;
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background: var(--primary_color);
      border-radius: 1rem;
    }

    scrollbar-base-color: var(--primary_color);
  }

  .x-icon {
    cursor: pointer;
  }

  .subtotal-value-and-buttons {
    margin-top: auto;

    .group-buttons {
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 0.4rem;
    }

    .group-buttons,
    .group-buttons a,
    button {
      width: 100%;
    }
  }

  .subtotal-value {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.2rem;
    color: var(--primary_color);
    font-weight: 700;
    margin-bottom: 1rem;

    strong {
      font-size: 1.5rem;
      font-weight: 900;
    }
  }

  .mini-cart-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    width: 100%;
    height: 3rem;
    max-width: 26rem;
    font-size: 1rem;
    font-weight: 700;
    color: var(--white);
    background-color: var(--primary_color);
    border: 0.1rem solid var(--primary_color);
    border-radius: 0.2rem;
    padding: 0.4rem 1.2rem;
  }

  .mini-cart-button.outline {
    color: var(--primary_color);
    background-color: transparent;
    padding: 0.4rem 0.6rem;
  }

  @media (max-width: 768px) {
    .mini-cart-button {
      min-width: 5rem;
    }
  }
`;
